
import { AppError } from 'src/app/common/app-error';

export class Unauthorized extends AppError { }
